import tokenSlice from 'reducers/token/reducer';

const { actions, reducer } = tokenSlice;

export const tokenActions = actions;

export default reducer;
